<template>
  <div>
    <div class="panel">
      <div class="label">标题</div>
      <div class="value3">专属区域申报_{{ extra.belongProvince }}{{ extra.belongCity }}{{ extra.district }}_{{ extra.deptName }}</div>
      <div class="label">主要负责人：</div>
      <div class="value1">{{ extra.chargeUserName }}</div>
      <div class="label">所属部门：</div>
      <div class="value2">{{ extra.deptName }}</div>
      <div class="label">商务对接人：</div>
      <div class="value1">{{ extra.businessUserName }}</div>
      <div class="label">技术对接人：</div>
      <div class="value2">{{ extra.technologyUserName }}</div>
      <div class="label">申请说明：</div>
      <div class="value3">{{ extra.remark }}</div>
      <div class="label">申报地市：</div>
      <div class="value1">{{ extra.belongProvince }}{{ extra.belongCity }}{{ extra.district }}</div>
      <div class="label">申报区域：</div>
      <div class="value2">{{ extra.areaName }}-{{ extra.subAreaName }}-{{ extra.l3AreaName }}</div>
      <div class="label">客户关系：</div>
      <div class="value3">{{ extra.customerRelationship }}</div>
      <div class="label">互访带队领导</div>
      <div class="value1">{{ extra.visitLeaderName }}</div>
      <div class="label">互访日期</div>
      <div class="value2">{{ dateFormatter(extra.visitDate) }}</div>
    </div>
    <Padding />
    <div style="margin-top: 20px;">
      <div>申报区域业绩</div>
      <a-table bordered :dataSource="JSON.parse(extra.contractAmountYear)" :pagination="false">
        <a-table-column title="合同签订年份" align="center">
          <template slot-scope="text">
            {{ text.year }}
          </template>
        </a-table-column>
        <a-table-column title="合同总金额（万元）" align="center">
          <template slot-scope="text">
            {{ text.amount }}
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getName } from "@/utils/clock";
import moment from "moment";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return this.detail.extra
        ? {
          ...this.detail.extra,
        }
        : {};
    },
  },
  methods: {
    getName,
    dateFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    renderStaff(str) {
      let msg = "";
      try {
        const list = JSON.parse(str);
        msg = list.map((item) => item.userName).join("，");
      } catch (error) {
        msg = str;
      }

      return msg;
    },
  },
};
</script>


<style lang="less" scoped>
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  &>div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>